import React, { useState, useEffect } from "react";
import { TabPane, Badge, Button } from "reactstrap";
import { Resultset, ResponseDetail, PersonalRow } from "components/response";
import { TopicSelector } from "components/topic/TopicSelector";
import { QueryActions } from "components/personal";
import styles from "./PersonalTab.module.css";
import { useQuery, useTopic, useAuth } from "hooks";
import { QueryTypeLabel } from "data/Types";
import { FA } from "components/FA";
import { GetFieldsList } from "components/Utils";
import { LoginButton } from "account/Login";

const PersonalTab = ({ tabId, className }) => {
  const [detail, setDetail] = useState(null);
  const { query, resultset, actions } = useQuery();
  const { topics } = useTopic();
  const auth = useAuth();
  const detailId = (detail && detail.id) || null;
  useEffect(() => {
    if (detailId != null) setDetail(resultset.find((r) => r.id === detailId));
  }, [resultset, detailId]);
  const classNames = [styles.personalTab, className];
  classNames.push(detail != null ? styles.hasDetails : styles.default);
  if (!query) {
    return (
      <TabPane
        tabId={tabId}
        className={classNames.filter((_) => _ != null).join(" ")}
      >
        <div className={styles.summaryWrapper}>
          {auth.user ? (
            <>
              <p>
                Please select an already saved query or save the current query
                to see your personalized results.
              </p>
              <Button onClick={actions.create} color="success" size="sm">
                <FA icon="star" size="xs" /> Save
              </Button>
            </>
          ) : (
            <LoginButton text="This feature is for logged in users only. Please login to personalize your results." />
          )}
        </div>
      </TabPane>
    );
  }
  const result = { ...query.report, docsCount: resultset.length };
  return (
    <TabPane
      tabId={tabId}
      className={classNames.filter((_) => _ != null).join(" ")}
    >
      <div className={styles.report}>
        <div className={styles.summary}>
          <div className={styles.summaryWrapper}>
            <QueryActions />
            <dl>
              <dt>Topic</dt>
              <dd>
                <TopicSelector
                  topics={topics}
                  value={query.topicId || "none"}
                  onTopicSelect={(topic) =>
                    (!topic || topic.id !== query.topicId) &&
                    actions.topic(topic ? topic.id : query.topicId)
                  }
                  right={false}
                />
              </dd>
              <dt>Query</dt>
              <dd>{query.parameters.query}</dd>
              <dt>
                Type{" "}
                <Badge color="success" pill>
                  {query.parameters.isAdvanced ? "Advanced" : "simple"}
                </Badge>
              </dt>
              <dd>{QueryTypeLabel[query.parameters.type]}</dd>
              {!query.parameters.isAdvanced && (
                <>
                  <dt>Queried Fields</dt>
                  <dd>{GetFieldsList(query.parameters.fields).join(", ")}</dd>
                </>
              )}
              <dt>Results</dt>
              <dd>
                <span title="Saved results">
                  {(resultset.length || 0).toLocaleString()}
                </span>
                /
                <span title="Found results">
                  {(query.report.docsCount || 0).toLocaleString()}
                </span>
              </dd>
              <dt>Summary:</dt>
              <dd>{query.report.summary}</dd>
            </dl>
          </div>
        </div>
        <Resultset
          className={`${styles.list}${
            resultset.length ? ` ${styles.minHeight}` : ""
          }`}
          setDetail={setDetail}
          status={1}
          result={result}
          execute={() => console.warn("PersonalTab: Pagination not supported!")}
          detailId={detail != null ? detail.id : -1}
          RowComponent={PersonalRow}
        />
      </div>
      {detail != null && (
        <ResponseDetail
          className={styles.detail}
          response={detail}
          handleClose={() => setDetail(null)}
          personal
        />
      )}
    </TabPane>
  );
};

export { PersonalTab };
